<script lang="ts">
  const steps = [
    {
      label: 'Fill up the form',
      active: true,
    },
    {
      label: 'Book an Appointment',
    },
  ];
</script>

<header class="booking-progress">
  <h3 class="title">Fill up the form</h3>
  <ul class="progress">
    {#each steps as step, i}
      <li class:active={step.active}>
        <span class="number">
          {i + 1}
        </span>
        {step.label}
      </li>
    {/each}
  </ul>
</header>

<style lang="scss">
  .booking-progress {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-micro);
    margin-bottom: var(--spacing-small);
  }

  .title {
    font-size: 18px;
    line-height: 28px;
  }

  .progress {
    display: flex;
    list-style: none;
    justify-content: center;
    padding: 0 var(--spacing-huge);

    li {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1 1 0px;
      gap: 6px;
      font-size: 12px;

      &:not(:last-child)::after {
        content: '';
        position: absolute;
        top: 9px;
        left: 50%;
        width: 100%;
        height: 2px;
        background-color: var(--color-neutralExtraLight);
      }

      .number {
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        background-color: #fff;
        color: var(--color-neutralGreyLight);
        border: 1px solid var(--color-neutralGreyLight);
        z-index: 1;
      }

      &.active {
        color: var(--vlt-lp-accent);

        .number {
          background-color: var(--vlt-lp-accent);
          color: var(--vlt-lp-accent-text);
          border-color: var(--vlt-lp-accent);
        }
      }
    }
  }
</style>
